import { useMemo } from 'react';
// @ts-ignore
import { useProperty } from '@vibesites/runtime/react';

const EXCLUDED_TITLES = new Set(['logo', 'other', 'floorplan']);

/**
 * Returns the indices of photo_gallery entries whose title is NOT
 * Logo, Other, or Floorplan. Components should use these as the
 * defaultIndex in their sourceBinding slot definitions so that
 * photo_0 maps to the first usable photo, photo_1 to the second, etc.
 */
export function useFilteredGalleryIndices(): number[] {
  const property = useProperty();
  return useMemo(() => {
    const gallery = property?.photo_gallery;
    if (!Array.isArray(gallery)) return [];
    return gallery
      .map((item: any, i: number) => ({ index: i, title: (item.title || '').toLowerCase().trim() }))
      .filter(({ title }) => !EXCLUDED_TITLES.has(title))
      .map(({ index }) => index);
  }, [property?.photo_gallery]);
}
